import { StyledSpinnerCircle, StyledSpinnerContainer } from './styles';

interface StyledSpinnerContainerProps {
  size?: string;
  borderColor?: string;
  borderWidth?: number;
  children?: React.ReactNode;
  spin: boolean;
}

const LoadingSpinner = ({
  size = '50%',
  borderColor = '#a748ff',
  borderWidth = 3,
  spin = false,
  children,
}: StyledSpinnerContainerProps) => {
  return (
    <StyledSpinnerContainer initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      {spin && (
        <>
          {[...Array(4)].map((_, index) => (
            <StyledSpinnerCircle
              key={index}
              width={size}
              height={size}
              style={{
                animationDelay: `-${index * 0.15}s`,
                borderWidth,
                borderColor: `${borderColor} transparent transparent transparent`,
              }}
            />
          ))}
        </>
      )}
      <div
        style={{
          opacity: spin ? 0.05 : 1,
        }}
      >
        {children}
      </div>
    </StyledSpinnerContainer>
  );
};

export default LoadingSpinner;
